import React from 'react'
import HeaderOne from '../Components/Header/HeaderOne'
import Breadcrumb from '../Components/BreadCrumb/Breadcrumb'
import CartInner from '../Components/Shop/CartInner'
import FooterFour from '../Components/Footer/FooterFour'
import ScrollToTop from '../Components/ScrollToTop'
import SEO from '../Components/SEO/SEO'

function Cart() {
    return (
        <>
            <SEO 
                title="Shopping Cart - Tourm Travel Shop"
                description="Review your shopping cart items before checkout."
                url="/cart"
            />
            <HeaderOne />
            <Breadcrumb
                title='Cart Page'
            />
            <CartInner />
            <FooterFour />
            <ScrollToTop />
        </>
    )
}

export default Cart
